import CrewDetail from "./CrewDetail";

export default CrewDetail;